export enum OAuthApplicationType {
  PAYMENT = "payment"
}
export enum OAuthConnection {
  ABORTED = "-1",
  ERROR = "0",
  SUCCESS = "1"
}
